export default __webpack_public_path__ + "static/media/2013-AMcover.1c32fb90.png";